import { useState, useRef, useEffect } from "react";
import { ChevronDown, Plus, X } from "lucide-react";

const countries = [
  // Afrique du Nord & Maghreb
  { code: "TN", prefix: "+216", name: "Tunisie", flag: "\u{1F1F9}\u{1F1F3}" },
  { code: "MA", prefix: "+212", name: "Maroc", flag: "\u{1F1F2}\u{1F1E6}" },
  { code: "DZ", prefix: "+213", name: "Algérie", flag: "\u{1F1E9}\u{1F1FF}" },
  { code: "LY", prefix: "+218", name: "Libye", flag: "\u{1F1F1}\u{1F1FE}" },
  { code: "EG", prefix: "+20", name: "Égypte", flag: "\u{1F1EA}\u{1F1EC}" },
  { code: "MR", prefix: "+222", name: "Mauritanie", flag: "\u{1F1F2}\u{1F1F7}" },
  // Moyen-Orient & Golfe
  { code: "SA", prefix: "+966", name: "Arabie Saoudite", flag: "\u{1F1F8}\u{1F1E6}" },
  { code: "AE", prefix: "+971", name: "Émirats Arabes Unis", flag: "\u{1F1E6}\u{1F1EA}" },
  { code: "QA", prefix: "+974", name: "Qatar", flag: "\u{1F1F6}\u{1F1E6}" },
  { code: "OM", prefix: "+968", name: "Oman", flag: "\u{1F1F4}\u{1F1F2}" },
  { code: "KW", prefix: "+965", name: "Koweït", flag: "\u{1F1F0}\u{1F1FC}" },
  { code: "BH", prefix: "+973", name: "Bahreïn", flag: "\u{1F1E7}\u{1F1ED}" },
  { code: "JO", prefix: "+962", name: "Jordanie", flag: "\u{1F1EF}\u{1F1F4}" },
  { code: "LB", prefix: "+961", name: "Liban", flag: "\u{1F1F1}\u{1F1E7}" },
  { code: "IQ", prefix: "+964", name: "Irak", flag: "\u{1F1EE}\u{1F1F6}" },
  { code: "PS", prefix: "+970", name: "Palestine", flag: "\u{1F1F5}\u{1F1F8}" },
  { code: "YE", prefix: "+967", name: "Yémen", flag: "\u{1F1FE}\u{1F1EA}" },
  { code: "SY", prefix: "+963", name: "Syrie", flag: "\u{1F1F8}\u{1F1FE}" },
  // Europe
  { code: "FR", prefix: "+33", name: "France", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "DE", prefix: "+49", name: "Allemagne", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "IT", prefix: "+39", name: "Italie", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "ES", prefix: "+34", name: "Espagne", flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "GB", prefix: "+44", name: "Royaume-Uni", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "BE", prefix: "+32", name: "Belgique", flag: "\u{1F1E7}\u{1F1EA}" },
  { code: "CH", prefix: "+41", name: "Suisse", flag: "\u{1F1E8}\u{1F1ED}" },
  { code: "NL", prefix: "+31", name: "Pays-Bas", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "PT", prefix: "+351", name: "Portugal", flag: "\u{1F1F5}\u{1F1F9}" },
  { code: "AT", prefix: "+43", name: "Autriche", flag: "\u{1F1E6}\u{1F1F9}" },
  { code: "SE", prefix: "+46", name: "Suède", flag: "\u{1F1F8}\u{1F1EA}" },
  { code: "NO", prefix: "+47", name: "Norvège", flag: "\u{1F1F3}\u{1F1F4}" },
  { code: "DK", prefix: "+45", name: "Danemark", flag: "\u{1F1E9}\u{1F1F0}" },
  { code: "FI", prefix: "+358", name: "Finlande", flag: "\u{1F1EB}\u{1F1EE}" },
  { code: "PL", prefix: "+48", name: "Pologne", flag: "\u{1F1F5}\u{1F1F1}" },
  { code: "GR", prefix: "+30", name: "Grèce", flag: "\u{1F1EC}\u{1F1F7}" },
  { code: "CZ", prefix: "+420", name: "Tchéquie", flag: "\u{1F1E8}\u{1F1FF}" },
  { code: "RO", prefix: "+40", name: "Roumanie", flag: "\u{1F1F7}\u{1F1F4}" },
  { code: "HU", prefix: "+36", name: "Hongrie", flag: "\u{1F1ED}\u{1F1FA}" },
  { code: "IE", prefix: "+353", name: "Irlande", flag: "\u{1F1EE}\u{1F1EA}" },
  { code: "LU", prefix: "+352", name: "Luxembourg", flag: "\u{1F1F1}\u{1F1FA}" },
  { code: "RU", prefix: "+7", name: "Russie", flag: "\u{1F1F7}\u{1F1FA}" },
  { code: "UA", prefix: "+380", name: "Ukraine", flag: "\u{1F1FA}\u{1F1E6}" },
  // Turquie
  { code: "TR", prefix: "+90", name: "Turquie", flag: "\u{1F1F9}\u{1F1F7}" },
  // Amérique
  { code: "US", prefix: "+1", name: "États-Unis", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "CA", prefix: "+1", name: "Canada", flag: "\u{1F1E8}\u{1F1E6}" },
  { code: "BR", prefix: "+55", name: "Brésil", flag: "\u{1F1E7}\u{1F1F7}" },
  { code: "MX", prefix: "+52", name: "Mexique", flag: "\u{1F1F2}\u{1F1FD}" },
  { code: "AR", prefix: "+54", name: "Argentine", flag: "\u{1F1E6}\u{1F1F7}" },
  { code: "CO", prefix: "+57", name: "Colombie", flag: "\u{1F1E8}\u{1F1F4}" },
  { code: "CL", prefix: "+56", name: "Chili", flag: "\u{1F1E8}\u{1F1F1}" },
  // Afrique subsaharienne
  { code: "SN", prefix: "+221", name: "Sénégal", flag: "\u{1F1F8}\u{1F1F3}" },
  { code: "CI", prefix: "+225", name: "Côte d'Ivoire", flag: "\u{1F1E8}\u{1F1EE}" },
  { code: "CM", prefix: "+237", name: "Cameroun", flag: "\u{1F1E8}\u{1F1F2}" },
  { code: "NG", prefix: "+234", name: "Nigeria", flag: "\u{1F1F3}\u{1F1EC}" },
  { code: "GH", prefix: "+233", name: "Ghana", flag: "\u{1F1EC}\u{1F1ED}" },
  { code: "KE", prefix: "+254", name: "Kenya", flag: "\u{1F1F0}\u{1F1EA}" },
  { code: "ZA", prefix: "+27", name: "Afrique du Sud", flag: "\u{1F1FF}\u{1F1E6}" },
  { code: "CD", prefix: "+243", name: "RD Congo", flag: "\u{1F1E8}\u{1F1E9}" },
  { code: "GA", prefix: "+241", name: "Gabon", flag: "\u{1F1EC}\u{1F1E6}" },
  { code: "ML", prefix: "+223", name: "Mali", flag: "\u{1F1F2}\u{1F1F1}" },
  { code: "BF", prefix: "+226", name: "Burkina Faso", flag: "\u{1F1E7}\u{1F1EB}" },
  { code: "NE", prefix: "+227", name: "Niger", flag: "\u{1F1F3}\u{1F1EA}" },
  { code: "TD", prefix: "+235", name: "Tchad", flag: "\u{1F1F9}\u{1F1E9}" },
  { code: "MG", prefix: "+261", name: "Madagascar", flag: "\u{1F1F2}\u{1F1EC}" },
  { code: "DJ", prefix: "+253", name: "Djibouti", flag: "\u{1F1E9}\u{1F1EF}" },
  { code: "SO", prefix: "+252", name: "Somalie", flag: "\u{1F1F8}\u{1F1F4}" },
  { code: "SD", prefix: "+249", name: "Soudan", flag: "\u{1F1F8}\u{1F1E9}" },
  // Asie
  { code: "CN", prefix: "+86", name: "Chine", flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "JP", prefix: "+81", name: "Japon", flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "KR", prefix: "+82", name: "Corée du Sud", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "IN", prefix: "+91", name: "Inde", flag: "\u{1F1EE}\u{1F1F3}" },
  { code: "PK", prefix: "+92", name: "Pakistan", flag: "\u{1F1F5}\u{1F1F0}" },
  { code: "MY", prefix: "+60", name: "Malaisie", flag: "\u{1F1F2}\u{1F1FE}" },
  { code: "ID", prefix: "+62", name: "Indonésie", flag: "\u{1F1EE}\u{1F1E9}" },
  { code: "SG", prefix: "+65", name: "Singapour", flag: "\u{1F1F8}\u{1F1EC}" },
  { code: "TH", prefix: "+66", name: "Thaïlande", flag: "\u{1F1F9}\u{1F1ED}" },
  // Océanie
  { code: "AU", prefix: "+61", name: "Australie", flag: "\u{1F1E6}\u{1F1FA}" },
  { code: "NZ", prefix: "+64", name: "Nouvelle-Zélande", flag: "\u{1F1F3}\u{1F1FF}" },
];

// Parse un numéro stocké en BDD (ex: "+216 12345678") en { prefix, number }
function parsePhone(value, defaultPrefix = "+216") {
  if (!value) return { prefix: defaultPrefix, number: "" };
  const trimmed = value.trim();
  const match = trimmed.match(/^(\+\d{1,4})\s*(.*)$/);
  if (match) return { prefix: match[1], number: match[2] };
  return { prefix: defaultPrefix, number: trimmed };
}

function SinglePhoneInput({ value, onChange, defaultPrefix = "+216" }) {
  const parsed = parsePhone(value, defaultPrefix);
  const [prefix, setPrefix] = useState(parsed.prefix);
  const [number, setNumber] = useState(parsed.number);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef();

  useEffect(() => {
    const p = parsePhone(value, defaultPrefix);
    setPrefix(p.prefix);
    setNumber(p.number);
  }, [value, defaultPrefix]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const emit = (p, n) => onChange(`${p} ${n}`.trim());

  const selectedCountry = countries.find(c => c.prefix === prefix) || countries[0];
  const filtered = search
    ? countries.filter(c => c.name.toLowerCase().includes(search.toLowerCase()) || c.prefix.includes(search))
    : countries;

  return (
    <div className="flex items-center gap-2">
      {/* Prefix selector */}
      <div className="relative flex-shrink-0" ref={dropdownRef}>
        <button
          type="button"
          onClick={() => { setOpen(!open); setSearch(""); }}
          className="flex items-center gap-1.5 px-3 py-2.5 border border-gray-200 rounded-xl text-sm bg-gray-50 hover:bg-gray-100 transition-colors min-w-[100px]"
        >
          <span className="text-base">{selectedCountry.flag}</span>
          <span className="text-slate-700 font-medium">{prefix}</span>
          <ChevronDown size={12} className="text-slate-400" />
        </button>

        {open && (
          <div className="absolute top-full left-0 mt-1 w-64 bg-white border border-gray-200 rounded-xl shadow-lg z-50 max-h-60 overflow-hidden">
            <div className="p-2 border-b border-gray-100">
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Rechercher un pays..."
                className="w-full px-2.5 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                autoFocus
              />
            </div>
            <div className="overflow-y-auto max-h-44">
              {filtered.map((c) => (
                <button
                  key={c.code}
                  type="button"
                  onClick={() => { setPrefix(c.prefix); emit(c.prefix, number); setOpen(false); }}
                  className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm hover:bg-blue-50 transition-colors ${c.prefix === prefix ? "bg-blue-50 text-blue-700" : "text-slate-700"}`}
                >
                  <span className="text-base">{c.flag}</span>
                  <span className="flex-1 text-left">{c.name}</span>
                  <span className="text-slate-400">{c.prefix}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Number input */}
      <input
        type="tel"
        value={number}
        onChange={(e) => { setNumber(e.target.value); emit(prefix, e.target.value); }}
        placeholder="12 345 678"
        className="flex-1 px-3 py-2.5 border border-gray-200 rounded-xl text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
      />
    </div>
  );
}

/**
 * PhoneInput - Composant téléphone avec préfixe pays
 *
 * @param {string[]} value - Tableau de numéros (ex: ["+216 12345678", "+33 612345678"])
 * @param {function} onChange - Callback avec le nouveau tableau
 * @param {string} defaultPrefix - Préfixe par défaut (ex: "+216")
 * @param {boolean} multiple - Autoriser plusieurs numéros (défaut: true)
 */
export default function PhoneInput({ value = [""], onChange, defaultPrefix = "+216", multiple = true }) {
  const phones = Array.isArray(value) ? value : [value || ""];

  const handleChange = (i, val) => {
    const arr = [...phones];
    arr[i] = val;
    onChange(arr);
  };

  const addPhone = () => onChange([...phones, ""]);
  const removePhone = (i) => onChange(phones.filter((_, j) => j !== i));

  return (
    <div className="space-y-2">
      {phones.map((tel, i) => (
        <div key={i} className="flex items-center gap-2">
          <div className="flex-1">
            <SinglePhoneInput
              value={tel}
              onChange={(val) => handleChange(i, val)}
              defaultPrefix={defaultPrefix}
            />
          </div>
          {multiple && phones.length > 1 && (
            <button type="button" onClick={() => removePhone(i)} className="p-2 hover:bg-red-50 rounded-lg transition-colors">
              <X size={14} className="text-red-400" />
            </button>
          )}
        </div>
      ))}
      {multiple && (
        <button
          type="button"
          onClick={addPhone}
          className="mt-1 w-full flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-200 rounded-xl text-sm text-slate-600 hover:bg-gray-50 transition-colors"
        >
          <Plus size={16} /> Ajouter un numéro
        </button>
      )}
    </div>
  );
}
